import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Target — concentric rings with a centre dot and four short
 *  crosshair ticks at the cardinal compass points. Means "goal /
 *  focus / objective" in the taxonomy picker. */
export function IcnTarget(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="target">
      <circle cx="8" cy="8" r="6" />
      <circle cx="8" cy="8" r="3.5" />
      <circle cx="8" cy="8" r="0.9" fill="currentColor" stroke="none" />
      {/* Crosshairs */}
      <path d="M8 1 V2.5" />
      <path d="M8 13.5 V15" />
      <path d="M1 8 H2.5" />
      <path d="M13.5 8 H15" />
    </Svg>
  );
}
